import {
  AnimaticIconShelf,
  AnimaticShelf,
  AnimaticShelfKind,
  AnimaticValueShelf,
  AnimaticValueShelfItem,
  AnimaticValueStateConfig,
  IconConfig,
  IconStateConfig,
} from '@repo/sdk/models/components';

import { getActiveState } from '@/features/equipment-browser/conditional-evaluator/get-active-state';

// Helper function to get the icon configs for an icon shelf based on the active state
const getShelfIcons = (iconShelf: AnimaticIconShelf): IconConfig[] => {
  const iconConfigs: IconConfig[] = [];
  iconShelf.icons.forEach((icon) => {
    const activeIconState = getActiveState<IconStateConfig>({
      states: icon.states,
    });
    if (activeIconState && activeIconState.config) {
      iconConfigs.push(activeIconState.config);
    }
  });
  return iconConfigs;
};

// Helper function to get the value items for a value shelf based on the active state
const getShelfValues = (valueShelf: AnimaticValueShelf): AnimaticValueShelfItem[] => {
  const valueItems: AnimaticValueShelfItem[] = [];
  valueShelf.items.forEach((item) => {
    const activeValueState = getActiveState<AnimaticValueStateConfig>({
      states: item.states,
    });
    if (activeValueState) {
      valueItems.push(activeValueState.config);
    }
  });
  return valueItems;
};

type AnimaticShelfConfigs = {
  icons: IconConfig[];
  kind: AnimaticShelfKind | undefined;
  title: string | undefined;
  values: AnimaticValueShelfItem[];
};

// Main function to get the animatic shelf configs for an equipment
export const getAnimaticShelfConfigs = (
  animaticShelf?: AnimaticShelf
): AnimaticShelfConfigs | undefined => {
  if (!animaticShelf || !animaticShelf.kind) {
    return {
      icons: [],
      kind: undefined,
      title: undefined,
      values: [],
    };
  }
  const shelfKind = animaticShelf.kind;
  const title = animaticShelf.title;

  switch (shelfKind) {
    case AnimaticShelfKind.Icon:
      return {
        icons: getShelfIcons(animaticShelf.iconShelf ?? { icons: [] }),
        kind: shelfKind,
        title: title,
        values: [],
      };
    case AnimaticShelfKind.Value:
      return {
        icons: [],
        kind: shelfKind,
        title: title,
        values: getShelfValues(animaticShelf.valueShelf ?? { items: [] }),
      };
    default:
      return undefined;
  }
};
